<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable :min-width="160" @resizing="onResize" :max-width="400" :draggable="false"
            :handles="['mr']" :w="206" :parent="false">
            <el-scrollbar>
              <tree :isSearch="isSearch" @initFun="initQuery" @nodeClick="nodeClick"></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item :label="$t('common.driverNum')">
                    <el-input size="mini" v-model="formInline.driverNum" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="input-with-select"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.driverName')">
                    <el-input size="mini" v-model="formInline.name" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="input-with-select"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.loginName')">
                    <el-input size="mini" v-model="formInline.loginName" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="input-with-select"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch" class="btn-chaxun">{{
                      $t("common.btn.search") }}</el-button>
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button v-if="isPrimaryKey('DRIVERFILE_PUSH')" type="text" :disabled="selected.length != 1"
                  @click="push()">{{ $t("common.btn.driverPush") }}</el-button>
                <!-- <el-button v-if="isPrimaryKey('DRIVERFILE_BIND')" type="text" :disabled="selected.length != 1"
                  @click="bindName()">{{ $t("common.btn.bind") }}</el-button> -->
                <!-- <el-button
                  type="text"
                  :disabled="selected.length != 1"
                  @click="changeDriverNum()"
                  >{{$t('DriverManagement.form.changeDriverNum')}}</el-button
                > -->
                <el-button v-if="isPrimaryKey('DRIVERFILE_TRANSFER')" type="text" :disabled="selected.length == 0"
                  @click="transferDriver">{{ $t("common.btn.transfer") }}</el-button>
                <el-button v-if="isPrimaryKey('DRIVERFILE_EDIT')" type="text" :disabled="selected.length != 1"
                  @click="editDriver">{{ $t("common.btn.edit") }}</el-button>
                <el-button v-if="isPrimaryKey('DRIVERFILE_DELETE')" type="text" :disabled="selected.length == 0"
                  @click="deleteDriver">{{ $t("common.btn.delete") }}</el-button>
                <el-button v-if="isPrimaryKey('DRIVERFILE_ADD')" type="text" @click="addDriver">{{ $t("common.btn.add")
                  }}</el-button>
                <el-button v-if="isPrimaryKey('DRIVERFILE_BATCHIMPORT')" type="text" @click="BulkImport">{{
                  $t("common.btn.batchUpload") }}</el-button>
                <el-button v-if="isPrimaryKey('DRIVERFILE_DOWN')" type="text" @click="downDriver">{{
                  $t("common.btn.download") }}</el-button>
              </div>
              <i-table :list="list" :height="height" ref="carTable" @handleSelectionChange="handleSelectionChange"
                :options="option" :columns="columns" :operates="operates"></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog width="1100px" :before-close="closeDia" class="carDialong" :title="diaTitle"
        :visible.sync="dialogFormVisible" :close-on-click-modal="false">
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item prop="driverNum" :label="$t('common.driverNum') + ':'" :label-width="formLabelWidth">
            <el-input size="small" :disabled="disabled" v-model="form.driverNum" autocomplete="off"
              class="halfStyle"></el-input>
          </el-form-item>
          <el-form-item prop="phone" :label="$t('DriverManagement.phone') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.phone" autocomplete="off" class="halfStyle"></el-input>
          </el-form-item>
          <el-form-item prop="name" :label="$t('common.driverName') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.name" autocomplete="off" class="halfStyle"></el-input>
          </el-form-item>
          <el-form-item prop="card" :label="$t('DriverManagement.card') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.card" autocomplete="off" class="halfStyle"></el-input>
          </el-form-item>
          <el-form-item :label="$t('DriverManagement.employmentStatus') + ':'" :label-width="formLabelWidth" prop="resignationState">
            <el-select v-model="form.resignationState" :placeholder="$t('common.choseTip')" class="halfStyle">
              <el-option :label="$t('DriverManagement.employed')" value="0"></el-option>
              <el-option :label="$t('DriverManagement.resigned')" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.resignationState == 1" prop="resignationTime" :label="$t('DriverManagement.resignationTime') + ':'" :label-width="formLabelWidth">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :placeholder="$t('common.choseTime')"
              v-model="form.resignationTime" class="halfStyle"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('DriverManagement.driverType') + ':'" :label-width="formLabelWidth" prop="driverType">
            <el-select v-model="form.driverType" :placeholder="$t('common.choseTip')" class="halfStyle">
              <el-option :label="$t('DriverManagement.operator')" value="0"></el-option>
              <el-option :label="$t('DriverManagement.staff')" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.driverType == 1" prop="staffNum" :label="$t('DriverManagement.staffIdNum') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.staffNum" autocomplete="off" class="halfStyle"></el-input>
          </el-form-item>
          <el-form-item prop="remarks" :label="$t('common.remark') + ':'" :label-width="formLabelWidth"
            class="remarkStyle">
            <el-input type="textarea" :rows="2" size="small" v-model="form.remarks" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <div v-if="isShow">
            <el-form-item prop="isRelevancy" :label="$t('DriverManagement.linkAccount')" :label-width="formLabelWidth"
              style="width: 100%">
              <el-checkbox v-model="form.isRelevancy">{{
                $t("DriverManagement.correct")
              }}</el-checkbox>
            </el-form-item>
            <div v-if="form.isRelevancy" style="border: 1px solid #b8b8b8; padding-top: 20px">
              <el-form-item prop="email" :label="$t('DriverManagement.email') + ':'" :label-width="formLabelWidth">
                <el-input size="small" v-model="form.email" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item prop="rolePower" :label="$t('common.btn.rolePower') + ':'"
                :label-width="formLabelWidth">
                <el-select size="small" v-model="form.rolePower" :placeholder="$t('common.form.rolePower')">
                  <el-option v-for="item in RoleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="roleData" :label="$t('common.btn.roleData') + ':'"
                :label-width="formLabelWidth">
                <el-button class="btnStyle" @click="getPower">{{
                  $t("common.btn.roleData")
                }}</el-button>
              </el-form-item>
            </div>
          </div> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog width="620px" :before-close="closeTransferDia" class="transferDialong"
        :title="$t('DriverManagement.transfer')" :visible.sync="dialogTransferFormVisible"
        :close-on-click-modal="false">
        <el-form :rules="TransferRules" ref="TransferForm" :model="TransferForm">
          <el-form-item prop="driverNum" :label="$t('DriverManagement.driverNumBelong') + ':'"
            :label-width="LabelWidth">
            <el-input type="textarea" :rows="2" size="small" v-model="TransferForm.driverNum"
              autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="roleId" :label="$t('BatteryFile.roleId') + ':'" :label-width="LabelWidth">
            <el-scrollbar>
              <tree :isSearch="isSearch" @nodeClick="changeClick"></tree>
            </el-scrollbar>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleTransfer('TransferForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitTransferForm('TransferForm')">{{ $t("common.btn.confirm")
            }}</el-button>
        </div>
      </el-dialog>
      <el-dialog width="620px" :before-close="closeBatchDia" :title="$t('common.btn.batchUpload')"
        :visible.sync="dialogBatchFormVisible" class="batchDialong" :close-on-click-modal="false">
        <div class="right-file">
          <el-button type="text" size="mini" @click="TemplateFile()">{{
            $t("common.btn.downloadModelFile")
          }}</el-button>
        </div>
        <div class="upload-file">
          <img src="../../../assets/images/upload.png" />
          <div>{{ $t("common.btn.clickUploadFile") }}</div>
          <input @change="uploadFile()" id="uploadDom" type="file" style="display: none;" />
          <el-button type="primary" size="small" @click="triggerFileUpload()">{{ $t("common.btn.uploadFile") }}</el-button>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogBatchFormVisible = false" class="btn-del">{{
            $t("common.btn.cancel")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog width="620px" :before-close="closeCarDia" class="addDialong" :title="$t('common.btn.edit')"
        :visible.sync="dialogCarFormVisible" :close-on-click-modal="false">
        <el-form :rules="ChangeCarRules" ref="ChangeCarForm" :model="ChangeCarForm">
          <div v-if="isShow">
            <el-form-item prop="driverNum" :label="$t('common.driverNum') + ':'" :label-width="LabelWidth">
              <el-input size="small" disabled v-model="ChangeCarForm.driverNum" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="newDriverNum" :label="$t('DriverManagement.newDriverNum') + ':'"
              :label-width="LabelWidth">
              <el-input size="small" v-model="ChangeCarForm.newDriverNum" autocomplete="off"></el-input>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item prop="driverNum" :label="$t('common.driverNum') + ':'" :label-width="LabelWidth"
              class="form-btn">
              <el-input size="small" disabled v-model="ChangeCarForm.driverNum" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="loginName" :label="$t('DriverManagement.loginName') + ':'" :label-width="LabelWidth"
              class="form-btn">
              <el-input size="small" v-model="ChangeCarForm.loginName" autocomplete="off"></el-input>
              <el-button v-if="isDisplay" @click="Relieve()">{{
                $t("common.btn.unBind")
              }}</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleCarChange('ChangeCarForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitCarForm('ChangeCarForm')">{{ $t("common.btn.confirm")
            }}</el-button>
        </div>
      </el-dialog>
      <el-dialog v-if="diaHidden" class="treeDialong" :title="$t('common.btn.roleData')"
        :visible.sync="dialogPowerVisible" width="520px" :before-close="handleClose" :close-on-click-modal="false">
        <div>
          <div>
            <el-input size="small" :placeholder="$t('common.filterTip')" v-model="filterText">
            </el-input>
            <div style="height: 380px">
              <el-scrollbar>
                <el-tree :data="data" show-checkbox ref="tree" node-key="label" :check-on-click-node="false"
                  :default-expanded-keys="keyList" :default-checked-keys="keyList" :filter-node-method="filterNode"
                  :props="defaultProps">
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="handleClose">{{
              $t("common.btn.cancel")
            }}</el-button>
            <el-button size="small" type="primary" @click="submit('form')">{{
              $t("common.btn.confirm")
            }}</el-button>
          </span>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DriverFile from "./DriverFile.js";
export default DriverFile;
</script>

<style lang="less" scoped>
.halfStyle {
  ::v-deep .el-input {
    width: 360px !important;
  }
}

@import "../../../assets/styles/Style.less";
</style>
